import { useState } from 'react';

import { AxiosPrivate } from '../utils/axios';
import { ResponseException } from '../models';
import { UploadType } from './../constants';

export const useUploadForm = (type: UploadType = UploadType.Transcript) => {
  let url = '/files';
  switch (type) {
    case UploadType.CommentAttachment:
      url = '/comment-attachments';
      break;
    case UploadType.ResponseAttachment:
      url = '/response-attachments';
      break;
  }

  const [isFetching, setFetching] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);

  const upload = async (file: any, name: string) => {
    try {
      setFetching(true);
      setErrors([]);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', name);
      const res = await AxiosPrivate.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res;
    } catch (e) {
      setErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setFetching(false);
    }
  };

  return {
    isFetching,
    upload,
    errors,
  };
};
